import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { Subject } from "rxjs";

import { InPageTab } from "../../shared/components/in-page-tabs/in-page-tabs/in-page-tabs.component";
import { computeUserProfileRouterUrl } from "../../shared/tool-functions/user-details-url";
import { User } from "../../users/models/users.entity";
import { UsersRepository } from "../../users/repositories/users.repository";

@Component({
    selector: 'app-sherpas',
    templateUrl: './sherpas.component.html',
    styleUrl: './sherpas.component.scss',
    encapsulation: ViewEncapsulation.None
})

export class SherpasComponent implements OnInit {

    newItems$ = new Subject<User[]>();

    scroll$ = new Subject<void>();

    tabs: InPageTab[] = [];

    constructor(
      public mainRepository: UsersRepository,
      private readonly router: Router,
      private readonly translate: TranslateService,
    ) {}

    ngOnInit(){
      this.tabs = [
        {
          icon: "award-prize",
          color: "#ff8b05",
          title: this.translate.instant('home.sherpasPage.tabCertified'),
          description: "",
          link: "#"
        },
        {
          icon: "suit-case",
          color: "#239692",
          title: this.translate.instant('home.sherpasPage.tabCorp'),
          description: "",
          link: "#"
        },
        {
          icon: "hands-heart",
          color: "#8c5fb0",
          title: this.translate.instant('home.sherpasPage.tabSupport'),
          description: "",
          link: "#"
        },
      ];
    }

    certifications = [
        {
            image: "icf"
        },
        {
            image: "sfcoach"
        },
        {
            image: "rncp"
        },
        {
            image: "emcc"
        }
    ]; 
    
    public goToUserDetails(user: User) {
      this.router.navigate(['home', ...computeUserProfileRouterUrl(user)]);
    }
    
    onScrollEvent() {
      this.scroll$.next();
    }
}
